import { Component, ElementRef, EventEmitter, HostListener,  Inject,  Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ILookup } from 'bi-interfaces/lib/interfaces/ILookup.interface';
import { CellClickEvent } from '@progress/kendo-angular-grid';
import { State, toODataString } from '@progress/kendo-data-query';
import { IDataSource } from 'bi-interfaces/lib/interfaces/IDataSource';
import { ModalService } from '../Services/modal.service';
import { FormControl } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BIModalComponent } from '../bi-modal/bi-modal.component';
import { DataTypes, Subscription } from 'bi-interfaces';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject, map } from 'rxjs';
import { BarcodeScannerComponent } from '../barcode-scanner/barcode-scanner.component';
import { TranslateService } from '@ngx-translate/core';
import { process } from '@progress/kendo-data-query';
import {SVGIcon, eyeIcon , moreHorizontalIcon} from '@progress/kendo-svg-icons'
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { BIPopupMenuComponent } from '../bi-popup-menu/bi-popup-menu.component';
import { ROUTES, Router, RouterModule } from '@angular/router';
import { LoggerService } from '../../services/logger.service';
import { inject } from "@angular/core"
import {Clipboard} from '@angular/cdk/clipboard';
import { event } from 'jquery';

@Component({
  selector: 'app-bi-lookup',
  templateUrl: './bi-lookup.component.html',
  styleUrls: ['./bi-lookup.component.scss'],
  providers: [{ provide: ICON_SETTINGS, useValue: { type: "font" } }],
})

export class BILookupComponent implements OnInit, ILookup, OnDestroy, OnChanges {

  @Output() ReturnedValueEmitter = new EventEmitter<any>();
  @Output() OnFocus = new EventEmitter<any>();
  @Output() OnOpen = new EventEmitter<any>();
  @Output() BeforeLoad = new EventEmitter<any>();
  @Output() AfterLoad = new EventEmitter<any>();
  @Output() OnEnterGrid = new EventEmitter<any>();
  @Output() OnClose = new EventEmitter<any>();
  @Output() OnHover = new EventEmitter<any>();
  @Output() OnChange = new EventEmitter<any>();
  @Output() ErrorStateEmitter = new EventEmitter<any>();
  @Output() multiRowsEmitter = new EventEmitter<any>();
  @Output() OnOpenSecondLkp = new EventEmitter<any>();
  @Input() hasSelection: boolean | undefined;
  @Input() DomID: string | undefined;
  @Input() Description: string | undefined;
  @Input() DataSource!: IDataSource;
  @Input() Key: string | undefined;
  @Input() classNameSelector!: string;
  @Input() Title!: string;
  @Input() rtlDescription!: string;
  @Input() IsDisabled: boolean;
  @Input() BindingProperty!: FormControl;
  @Input() Lookuptemplet: any;
  @Input() lookupValue: any;
  @Input() DisplayCancel: boolean;
  @Input() DataType!: string;
  @Input() hasSecondLkp!: boolean;
  @Input() setPreventCloseRow!: BehaviorSubject<boolean>;
  @Input() validateCheckExistence?: boolean;
  @Input() style?:string;
  @Input() route?:string;
  @Input() hasPendingChanges?:boolean;


//  public svgEye:SVGIcon= moreHorizontalIcon;
  Isvalid: boolean;
  SelectedRow: any;
  GoToDefinitionURl!: string;
  public opened!: boolean;
  ModalID!: string
  DescriptionText: string;
  GridDataLookupSubscription!: Subscription;
  gridData!: any[] | null;
  data$: any;
  ErrorMsg!: string;
  state: State = { skip: 0, take: 10 };
  lookupvale: any;
  multiSelectedRows!: any;
  hasMultiSelectedRows: any;
  dialogRef!: MatDialogRef<any>;
  mobile: boolean = false;
  EnteredValue: string = "";
  localDataBackup:any=null;
  currentFilter: any = null;
  @ViewChild(BIPopupMenuComponent)
  menu!: BIPopupMenuComponent;

  @ViewChild(Input)
  input!:ElementRef;

  router=inject(Router);
  clipboard=inject(Clipboard);
  loggerService =inject(LoggerService);

  constructor(public dialog: MatDialog, public translateService: TranslateService) {
    this.IsDisabled = false;
    this.Isvalid = true;
    this.DisplayCancel = true;
    this.DescriptionText = "";

  }

  @HostListener('document:contextmenu', ['$event'])
  clickout() {
    this.menu.close();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.BindingProperty?.getRawValue()) {
      this.Isvalid = true;
      this.ErrorMsg = '';
    }

    if (changes?.['DataSource']?.currentValue) {
      this.data$ = this.DataSource;
      this.CheckExistence();
    }
  }


  OnInputFocus() {
    this.OnFocus.emit(null);
  }

  public CloseModal(): void {
    this.OnClose.emit(null);
    this.state.skip = 0
    this.DataSource.state.skip = 0
    this.opened = false;
    this.setPreventCloseRow?.next(false);
  }

  OpenModal() {
    this.OnOpen.emit(null);
    this.opened = true;
    this.getLookupData();
    this.setPreventCloseRow?.next(true);

  }

  getLookupData(filter: any = null) {
    // in case of showing pop-up without html lookup componnet
    if (!this.data$) {
      this.ngOnInit();
    }
    this.DataSource?.read(filter == null ? `$skip=${this.DataSource.state.skip}&$top=10&$count=true` : filter);
    this.AfterLoad.emit(this.gridData);
  }

  ngOnInit(): void {
    this.ClearError();
    this.BeforeLoad.emit(null);
    this.CheckExistence();
    this.data$ = this.DataSource;
    if (this.GridDataLookupSubscription) this.GridDataLookupSubscription?.unsubscribe();
    this.GridDataLookupSubscription = this.data$?.subscribe((res: any) => {
      this.gridData = res.data;
      
      if ( 
        (this.opened && this.gridData && !this.BindingProperty && this.lookupValue) ||
        (!this.opened && this.gridData && this.BindingProperty && (this.BindingProperty?.getRawValue() == 0 || this.BindingProperty?.getRawValue()))) {
        if (this.gridData?.length) {
          this.SelectedRow = this.gridData[0];
          // this.ReturnedValueEmitter.emit(this.SelectedRow);
          this.ClearError();
          this.ErrorStateEmitter.emit({ ErrMsg: '', IsErrorHappened: false });
        }
        else {
          this.SetError(`${this.translateService.instant('cantfind')} ${this.translateService.instant(this.Key ?? '')} ${this.translateService.instant('withenteredvalue')} `)
          //  this.BindingProperty.setErrors({ isNotValidValue: this.ErrorMsg })
          this.ErrorStateEmitter.emit({ ErrMsg: `${this.translateService.instant('cantfind')} ${this.Key} ${this.translateService.instant('withenteredvalue')} `, IsErrorHappened: true });
        }
      }
    });

    this.ModalID = this.Key + '_' + this.DomID;
    this.BindingProperty?.registerOnChange(() => {
      if (this.BindingProperty.touched === false)
        this.ClearError();
    })

  }

  CheckExistence() {

    if (this.validateCheckExistence != false) {
      let result:string="";
      if (this.BindingProperty?.getRawValue() == 0 || this.BindingProperty?.getRawValue() || this.EnteredValue) {
        let SearchVal = (this.BindingProperty?.getRawValue() == 0 || this.BindingProperty?.getRawValue()) ?
          this.BindingProperty?.getRawValue() : this.EnteredValue;
        if(SearchVal === '' || SearchVal === null){
          return;
        }
        let filter = "";
        if (this.DataType === "numeric") filter = "$filter=" + this.DataSource.Key + " eq " + SearchVal;
        else filter = "$filter=" + this.DataSource.Key + " eq '" + SearchVal + "'";
        if(this.DataSource.APIURL){
          this.DataSource?.get(this.DataSource.formatAPIURLWithFilter(filter) + this.DataSource.formatFilter(filter))
            .subscribe((res: any) => {
              if (res.value?.length) {
                this.SelectedRow = res.value[0];
                result = res.value[0][this.DataSource.Key];
                if (result && this.EnteredValue && this.EnteredValue !== "" &&result !== this.EnteredValue)
                {
                 // this.EnteredValue = result;
                  this.changeTextValue(result)
                }
                this.ReturnedValueEmitter.emit(this.SelectedRow);
                this.ClearError();
                this.ErrorStateEmitter.emit({ ErrMsg: '', IsErrorHappened: false });
              }
              else if (res.length > 0) {
                this.SelectedRow = res[0];
                result = res[0][this.DataSource.Key];
                if (result && this.EnteredValue && this.EnteredValue !== "" &&result !== this.EnteredValue)
                {
                  //this.EnteredValue = result;
                  this.changeTextValue(result)
                }
                this.ReturnedValueEmitter.emit(this.SelectedRow);
                this.ClearError();
                this.ErrorStateEmitter.emit({ ErrMsg: '', IsErrorHappened: false });
              }
              else {
                this.SetError(`${this.translateService.instant('cantfind')} ${this.translateService.instant(this.Key ?? '')} ${this.translateService.instant('withenteredvalue')} `)
                this.ErrorStateEmitter.emit({ ErrMsg: `${this.translateService.instant('cantfind')} ${this.Key} ${this.translateService.instant('withenteredvalue')} `, IsErrorHappened: true });
              }
  
            });

        }
        else{
          console.error('APIURL is not defined with key' + this.DataSource.Key) // needs to be updated with appropriate message
        }
      }
    }
  }
  cellClickHandler(args: CellClickEvent) {
    this.SelectedRow = args.dataItem;
    this.ClearError();
  }
  OnInputHover() {
    if (this.Description) this.DescriptionText = this.SelectedRow ? this.SelectedRow[this.Description] : "";
    this.OnHover.emit(null);
  }
  public SetIsDisable(IsDisabled: boolean) {
    this.IsDisabled = IsDisabled
  }

  FilterChange(e: any) {
    if (this.DataSource?.IsClientSideFilter != true) {
      this.state.skip = e.skip;
      this.DataSource.state.skip = e.skip;
      this.DataSource.state.sort = e.sort;
      this.getLookupData(toODataString(e) + '&$count=true');
    } else {
      if (this.localDataBackup == null)
        this.localDataBackup = JSON.parse(JSON.stringify(this.DataSource.data));

      this.state.skip = e.skip;
      this.DataSource.state.skip = e.skip;
      this.DataSource.state.sort = e.sort;
      if (e.filter) {
        this.currentFilter = e.filter;
      } else {
        e.filter = this.currentFilter;
      }
      (this.DataSource.data as any) = process(this.localDataBackup.data, e);
      let lkpDSURL = this.DataSource.APIURL;
      this.DataSource.APIURL = '';
      this.DataSource.LocalData = true;
      this.DataSource.read('');
      this.DataSource.APIURL = lkpDSURL;
    }
  }
  
  SetError(ErrMsg: string) {
    this.Isvalid = false;
    this.ErrorMsg = ErrMsg
    if (this.BindingProperty) this.BindingProperty.setErrors({ 'incorrect': true });
  }
  ClearError() {
    this.Isvalid = true;
    this.ErrorMsg = '';
    if (this.BindingProperty) this.BindingProperty.setErrors(null);
  }
  Ok() {
    this.CloseModal();
    if(this.hasSelection){
      if (this.multiSelectedRows?.length > 0) {
        this.hasMultiSelectedRows = true;
      
        this.lookupValue = this.multiSelectedRows.map( (x:any)=> {
          const value = x[this.Key ?? ''];
          return typeof value === 'string' ? `'${value}'` : value;
        }).join(',');
        if (this.Key) {
          this.BindingProperty?.markAsDirty();
          this.BindingProperty?.patchValue(this.lookupValue);
        }
        this.multiRowsEmitter.emit(this.multiSelectedRows);
      }
    }else{

      if (this.Key && this.SelectedRow) {
        this.BindingProperty?.markAsDirty();
        this.BindingProperty?.patchValue(this.SelectedRow[this.Key]);
      }
      if (this.SelectedRow) {
        this.ReturnedValueEmitter.emit(this.SelectedRow);
        this.lookupValue = this.SelectedRow[this.DataSource.Key];
        if(this.BindingProperty)
        {
          this.lookupValue = this.BindingProperty?.getRawValue()
        }
      }
    
    }
  }
  Cancel() {
    this.CloseModal();
  }
  dblClickEvent() {
    this.Ok();
  }
  async OnTextChange(event: any): Promise<void> {
    this.changeTextValue(event.target.value);
    this.OnChange.emit(null);
  }
  showContextMenu(e: any) {
  }
  changeTextValue(value: any) {
    this.EnteredValue = value;
    this.lookupValue = value;
    this.BindingProperty?.markAsDirty();

    if (!value) {
      this.BindingProperty?.patchValue(null);
      this.ReturnedValueEmitter.emit(null);
      this.SelectedRow = null;
      this.lookupValue = null;
      return;
    }
    this.BindingProperty?.patchValue(value);
    if (this.DataType === DataTypes.NUMERIC && isNaN(Number(this.EnteredValue))) {
      this.SetError(`please enter numeric data `)
      this.ErrorStateEmitter.emit({ ErrMsg: `please enter numeric data`, IsErrorHappened: true });
    }
    else {
      this.CheckExistence();
      // this.DataType === DataTypes.NUMERIC ? this.DataSource.read( this.DataSource.Key + " eq " + EnteredValue) : this.DataSource.read( this.DataSource.Key + " eq '" + EnteredValue + "'");

    }
  }
  openDialog(): void {
    this.OpenModal()
    this.dialogRef = this.dialog.open(BIModalComponent, {
      data: this
    });

    this.dialogRef.afterClosed().subscribe(result => {
    });
  }
  openSecondLkp(): void {
    this.OnOpenSecondLkp.emit(null);
    const dialogRef = this.dialog.open(BarcodeScannerComponent, {

      minWidth: '90vw',
      minHeight: '40vh',
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.lookupValue = result;
        this.changeTextValue(result)
      }
      //ok()
      //this.animal = result;
    });
  }
  ngOnDestroy(): void {
    this.GridDataLookupSubscription?.unsubscribe();
    this.gridData = null
  }

  openMenu(e: MouseEvent) {
    if (!this.BindingProperty.dirty && ( this.route || this.IsDisabled || this.BindingProperty.disabled))
    {
      this.menu.open(e);
      e.preventDefault();
    }
  }


  GotoDefinition(): void{
    if (this.route && this.router)
    {
       if (!this.hasPendingChanges)
      // if (!this.SelectedRow.CheckPendingChange() )
       {
          const routingParameter = this.BindingProperty?.getRawValue() ?? '';
          this.router.navigate([this.route,routingParameter]);
       }
       else {
         this.alertShow(this.translateService.instant('Savependingchanges'), 1);
       }
   }
  }

  alertShow(content: string, type: number) {
    if (this.loggerService)
    {
      this.loggerService.Content = this.translateService.instant(content);
      this.loggerService.Type = type;
      this.loggerService.Show();
    }
  }

  copy()
  {
    this.clipboard.copy(this.BindingProperty?.getRawValue());

  }

  cut()
  {
    if (!(this.IsDisabled || this.BindingProperty?.disabled))
{
    this.clipboard.copy(this.BindingProperty?.getRawValue());
    this.lookupValue = '';
    this.changeTextValue('')
}
  }

  paste()
  {
    if (!(this.IsDisabled || this.BindingProperty?.disabled))
{
    //this.lookupValue = document.execCommand('paste')
   var str= navigator.clipboard.readText();
   this.lookupValue = str;
   this.changeTextValue(str)
}
  }




}

